export interface TextValidationOptions {
  maxCharacters?: number;
  removeNewLines?: boolean;
}

export function sanitizeTextContent(
  text: string,
  options: TextValidationOptions
): string {
  let sanitized = text;

  if (options.removeNewLines) {
    sanitized = sanitized.replace(/\r?\n|\r/g, '');
  }

  const maxCharacters = options?.maxCharacters as number;

  if (maxCharacters >= 0) {
    if (sanitized.length > maxCharacters) {
      sanitized = sanitized.slice(0, maxCharacters);
    }
  }

  return sanitized;
}
